import Page from "../Page";
import Api from "../Api";
import HttpClient from "../HttpClient";
import GetListQuery from "./GetListQuery";
import PdfAttachment from "./PdfAttachment";
import CreatePayload from "./CreatePayload";

class PdfAttachmentApi {
    // noinspection JSUnusedGlobalSymbols
    /**
     * Get PDF attachments
     * @author Kacper Faber
     * @since 0.2.0
     */
    static getList(query: GetListQuery): Promise<Page<PdfAttachment>> {
        const url = Api.getUrl('/api/pdf-attachment/');
        return HttpClient.get<Page<PdfAttachment>>(url, { ...query });
    }

    /**
     * Create new PdfAttachment
     * @author Kacper Faber
     * @since 0.2.0
     */
    static create(payload: CreatePayload): Promise<PdfAttachment> {
        const url = Api.getUrl('/api/pdf-attachment/');
        return HttpClient.postFormData(url, {}, { ...payload });
    }
}

// noinspection JSUnusedGlobalSymbols
export default PdfAttachmentApi;